import { animated } from 'react-spring';
import { cssVars, fadeInAnimation } from '@/app/styles';
import styled, { css } from 'styled-components';

const CARD_HEIGHT_PIXELS = '284px';
const CARD_WIDTH_PIXELS = '308px';

const propertyCardGridStyle = css`
  display: grid;
  margin-left: 0;
  margin-right: 0;
  grid-template-columns: repeat(auto-fill, ${CARD_WIDTH_PIXELS});
  grid-template-rows: repeat(auto-fill, ${CARD_HEIGHT_PIXELS});
  grid-auto-flow: row;
  grid-gap: 26px 17px;
  justify-content: center;

  ::-webkit-scrollbar {
    display: none;
  }
`;

const CardViewerWrapper = styled.div`
  height: 100%;
  .rs-pagination-btn > a {
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
  }
  .rs-pagination-btn.rs-pagination-btn-active > a {
    color: ${cssVars.color.rentalscapeBlue};
    font-size: 14px;
  }
`;

const PageWrapper = styled.div`
  overflow-y: scroll;
  overflow-x: hidden;
  scroll-behavior: ${(props) => (props.currentPage === 1 ? 'smooth' : 'unset')};
  position: relative;
  height: calc(100% - 70px);
  ${fadeInAnimation()}
`;

const PaginationWrapper = styled.div`
  padding: 15px;
  display: flex;
  width: 100%;
  height: 50px;
  justify-content: center;
`;

const PropertyCardGrid = styled.div`
  ${propertyCardGridStyle}
`;

const AnimatedGridWrapper = styled(animated.div)`
  position: absolute;
  height: 100%;
  width: 100%;
`;

export {
  propertyCardGridStyle,
  CARD_HEIGHT_PIXELS,
  CARD_WIDTH_PIXELS,
  CardViewerWrapper,
  PaginationWrapper,
  PageWrapper,
  PropertyCardGrid,
  AnimatedGridWrapper,
};
